import './modules/Gull/Framework/jqueryGlobal.js';
import './modules/Gull/Framework/bootstrapGlobal.js';

import appAutoload from './modules/VerzekeringsInzicht/App/autoload.js';
import frameworkAutoload from './modules/Gull/Framework/autoload.js';
import appRoutes from './routes/VerzekeringsInzicht/App/routes.js';
import frameworkRoutes from './routes/Gull/Framework/routes.js';

import App from './modules/Gull/Framework/app.js';
import BuildRouter from './modules/Gull/Framework/router-build.js';

let appInstance = new App(appAutoload, frameworkAutoload, appRoutes, frameworkRoutes);
appInstance.init(BuildRouter);
